import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { CalendarEventDetailsService } from 'app/_services/calendarEventDetails.service';
import { DialogsService } from 'app/_services/dialogs/dialogs.service';
import { NotificationService } from 'app/_services/notification.service';
import { EventDetail } from '../events';
import { EditEventDetailDialogComponent } from './edit-event-detail/edit-event-detail-dialog.component';

@Component({
    selector: 'app-event-details',
    templateUrl: './event-details.component.html',
    styleUrls: ['./event-details.component.scss'],
})
export class EventDetailsComponent implements OnInit {
    dataSource: MatTableDataSource<EventDetail>;
    displayedColumns: string[] = ['startDate', 'endDate', 'location', 'subtitle', 'actions'];
    columnsToDisplay = this.displayedColumns.slice();

    @Input() eventName: string;
    @Input() eventId: number;
    eventDetails: any[];

    @ViewChild(MatTable) table: MatTable<EventDetail>;

    constructor(
        private dialog: MatDialog,
        private dialogSerivce: DialogsService,
        private notificationService: NotificationService,
        private detailsService: CalendarEventDetailsService
    ) {}

    ngOnInit(): void {
        this.detailsService.getCalendarEventDetailsById(this.eventId).subscribe((details) => {
            this.eventDetails = details;
            this.dataSource = new MatTableDataSource(this.eventDetails);
        });
    }

    newEventDetail(): EventDetail {
        return {
            cancelled: false,
            endDate: null,
            endTime: null,
            instEventId: this.eventId,
            instId: 0, // Must be set to 0, since this column field is set as Identity in database
            location: '',
            startDate: null,
            startTime: null,
            tentative: false,
            subtitle: '',
            subtitleActive: false,
        };
    }

    openEditEventDetailDialog(eventDetail: EventDetail, title: string): MatDialogRef<EditEventDetailDialogComponent> {
        const eventName = this.eventName;
        const config: MatDialogConfig = {
            width: '80vw',
            maxWidth: '600px',
            panelClass: 'eventDetailEditor',
            data: { eventDetail, eventName, title },
        };

        return this.dialog.open(EditEventDetailDialogComponent, config);
    }

    addEventDetail(): void {
        const title = 'Add New Event Date';
        const eventDetails = this.eventDetails;

        const eventDetail = this.newEventDetail();

        const dialogResult = this.openEditEventDetailDialog(eventDetail, title);

        dialogResult.afterClosed().subscribe((result: EventDetail) => {
            if (!result) {
                return;
            }

            this.detailsService.createCalendarEventDetail(result).subscribe((res: EventDetail) => {
                eventDetails.push(res);
                this.table.renderRows();
                this.notificationService.showSuccess(`New Event Date has been added.`);
            });
        });
    }

    editEventDetail(eventDetail: EventDetail): void {
        const title = 'Edit Event Date';

        const dialogResult = this.openEditEventDetailDialog(eventDetail, title);

        dialogResult.afterClosed().subscribe((result: EventDetail) => {
            if (!result) {
                return;
            }

            this.detailsService.updateCalendarEventDetail(eventDetail.instId, result).subscribe((res: EventDetail) => {
                this.table.renderRows();
                this.notificationService.showSuccess(`Event Date has been updated.`);
            });
        });
    }

    deleteEventDetail(eventDetail: EventDetail): void {
        const dialogResult$ = this.dialogSerivce.OpenConfirmationDialog({
            TitleText: 'Delete Event Date',
            MessageText: 'Are you sure you want to delete this date for this event?',
            OKText: 'Yes, remove date',
            CancelText: 'No',
        });

        dialogResult$.subscribe((result) => {
            if (!result) {
                return;
            }

            const index = this.dataSource.data.indexOf(eventDetail, 0);

            if (index > -1) {
                this.dataSource.data.splice(index, 1);
            }

            this.detailsService.deleteCalendarEventDetail(eventDetail.instId).subscribe();
            this.table.renderRows();

            this.notificationService.showSuccess(`Event Date have been removed.`);
        });
    }
}
